module.exports = __webpack_public_path__ + "static/barra-centro2030-23b69b4b8c4f14a51914517c1458cb4b.png";